<template>
    <div class="text-center">
        
        <!-- <img v-show="isHdImageLoaded" @load="onHdImageLoad()" class="mb-2" :src="'/api/image/get/product/' + product.image" width="100%" height="100%"> -->
        <img v-show="!isHdImageLoaded" class="mb-2" :src="'/api/image/get/product/small/' + product.image" width="100%" height="100%">

        <div class="product-name">{{ product.title }}</div>
        <div class="text-left">

            <div class="row">
                <div class="col-9 price font-weight-bold">
                    <span class="product-price">{{ product.priceDiscounted }} </span>
                    <span v-if="product.discount" class="ml-1 line-through font-size-12 text-secondary" 
                            >{{ product.price }}</span>  
                </div>
                <div v-if="product.discount" class="col-3 my-auto text-right discount">
                    <span class="discountLabel-min" style="white-space: nowrap;">{{ product.discountStr }}</span>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

export default ({
    name: "ProductCard",
    props: {
        product: Object,
    },

    data() {
        return {
            isHdImageLoaded: false,
        };
    },

    methods: {
        onHdImageLoad() {
            this.isHdImageLoaded = true;
        },
    }

});
</script>

<style scoped>
.product-name {
    width: 100%;
    position: relative;
    font-size: 16px;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
    font-family: 'Space Grotesk';
    color: #121212;
    text-align: left;
    display: inline-block;
}

.product-price {
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    color: #121212;
}

.old-product-price {
    font-size: 14px;
    text-decoration: line-through;
    line-height: 22px;
    font-family: Inter;
    color: #a7a7a7;
}

.discountLabel-min {
    border-radius: 8px;
    background-color: #ff0000;
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #fff;
    padding: 2px 4px 2px 4px;
}

</style>